import {
  IProjectColors,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';
import {
  CUSTOM_SUBCATEGORY,
  CUSTOM_WORKSPACE_COLORS,
  INDIVIDUAL_WORKSPACES_CATEGORY,
  PRIVATE_OFFICES_SUBCATEGORY,
  WORKSTATIONS_SUBCATEGORY,
} from 'spw-constants';

export const getSubcategoryData = (
  subcategory: IProjectSpaceTypeSubcategory,
  projectColors: IProjectColors
) => {
  const defaultColor = projectColors[INDIVIDUAL_WORKSPACES_CATEGORY] as string;
  const subcategoryColors: Record<string, string> = {
    [WORKSTATIONS_SUBCATEGORY]:
      projectColors[CUSTOM_WORKSPACE_COLORS][1] || defaultColor,
    [PRIVATE_OFFICES_SUBCATEGORY]:
      projectColors[CUSTOM_WORKSPACE_COLORS][3] || defaultColor,
    [CUSTOM_SUBCATEGORY]:
      projectColors[CUSTOM_WORKSPACE_COLORS][7] || defaultColor,
  };

  return {
    title: `All ${subcategory?.name || ''}`,
    color:
      subcategoryColors[
        subcategory.defaultSpaceTypeCategory.category as string
      ] || defaultColor,
  };
};
